import { initializeApp } from 'firebase/app';
import { 
  getFirestore, 
  collection, 
  addDoc, 
  doc, 
  getDoc, 
  setDoc, 
  getDocs, 
  query, 
  where,
  updateDoc 
} from 'firebase/firestore';
import { 
  getAuth, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  updateProfile, 
  signOut, 
  reauthenticateWithCredential, 
  EmailAuthProvider, 
  updatePassword 
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBhkckjb_pyjA3jCp9RjzpysWsK1cPy8u4",
  authDomain: "luansodienthoai-fc074.firebaseapp.com",
  projectId: "luansodienthoai-fc074",
  storageBucket: "luansodienthoai-fc074.firebasestorage.app",
  messagingSenderId: "88955157562",
  appId: "1:88955157562:web:c928edbfe7a90bc5d0c903"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export const createUser = async (email, password, displayName, phoneNumber) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(userCredential.user, { displayName });
    const userDocRef = doc(db, 'users', userCredential.user.uid);
    
    // Calculate expiration date (30 days from creation)
    const expirationDate = new Date();
    expirationDate.setDate(expirationDate.getDate() + 30);
    
    await setDoc(userDocRef, {
      displayName: displayName,
      phoneNumber: phoneNumber,
      email: email,
      analysisCount: 0,
      lastAnalysisTime: null,
      maxAnalysisCount: 19,
      role: 'regular',
      createdAt: new Date(),
      expirationDate: expirationDate // Add expiration date
    });
    return userCredential.user;
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
};

export const signInUser = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    console.error("Error signing in:", error);
    throw error;
  }
};

export const signOutUser = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Error signing out:", error);
    throw error;
  }
};

export const getUserAnalysisCount = async (userId) => {
  if (!userId) return 0;
  const userDocRef = doc(db, 'users', userId);
  const userDoc = await getDoc(userDocRef);
  if (userDoc.exists()) {
    return userDoc.data().analysisCount || 0;
  }
  return 0;
};

export const incrementUserAnalysisCount = async (userId) => {
  if (!userId) return;
  const userDocRef = doc(db, 'users', userId);
  const userDoc = await getDoc(userDocRef);
  let currentCount = 0;
  let lastAnalysisTime = null;
  if (userDoc.exists()) {
    currentCount = userDoc.data().analysisCount || 0;
    lastAnalysisTime = userDoc.data().lastAnalysisTime || null;
  }
  await setDoc(userDocRef, { analysisCount: currentCount + 1, lastAnalysisTime: new Date() }, { merge: true });
};

export const getUserData = async (userId) => {
  if (!userId) return null;
  const userDocRef = doc(db, 'users', userId);
  const userDoc = await getDoc(userDocRef);
  if (userDoc.exists()) {
    return userDoc.data();
  }
  return null;
};

export const checkAuthorizedEmail = async (email) => {
  if (!email) return false;
  try {
    const authorizedEmailsRef = collection(db, 'authorizedEmails');
    const q = query(authorizedEmailsRef, where('email', '==', email));
    const querySnapshot = await getDocs(q);
    return !querySnapshot.empty;
  } catch (error) {
    console.error('Error checking authorized email:', error);
    return false;
  }
};

export {
  auth,
  db,
  doc,
  updateDoc,
  reauthenticateWithCredential,
  EmailAuthProvider,
  updatePassword
};
